import { jsx } from "@emotion/react/jsx-runtime";
import { useTranslation } from "react-i18next";
const AccomplishmentBadge = ({
  className,
  course
}) => {
  const {
    t
  } = useTranslation();
  return /* @__PURE__ */ jsx("img", { alt: t("AccomplishmentBadge.altText"), className, src: course.badgeUrl });
};
export {
  AccomplishmentBadge
};
